import { Column, Heading, Image, Paragraph, Row } from "@hex-insights/core";
import { useActivePageRegistration } from "@hex-insights/router";
import { ButtonLink, Icon, StaticURLs, Tile } from "@hex-insights/verita-romania.shared";
import { Main } from "../../../Components";
import { reEnrollmentGuardiansPageInfo } from "../GuardiansPage/pageinfo";
import { reEnrollmentIndexPageInfo } from "./pageinfo";
import generalStyles from "../general.module.css";
import styles from "./styles.module.css";

export function ReEnrollmentIndexPage() {
	useActivePageRegistration(reEnrollmentIndexPageInfo);

	return (
		<Main className={styles["main"]}>
			<Column justify="center" className={styles["main-column"]}>
				<Tile className={styles["main-tile"]}>
					<Tile.Body className={styles["main-tile__body"]}>
						<Column justify="spaced-start" verticalSpacing="3rem">
							<Image
								src={StaticURLs.Images.veritaLogoAndWordmark}
								width={200}
								height={115}
								sizing="width-scaled"
								style={{ margin: "0 auto" }}
							/>

							<Column justify="spaced-start" verticalSpacing="1.5rem">
								<Heading.H2 noMargin className={generalStyles["heading"] + " " + styles["heading"]}>
									2024-2025 Re-Enrollment
								</Heading.H2>

								<Paragraph style={{ textAlign: "center", margin: "0 auto", maxWidth: "19rem" }}>
									We invite you to choose the meal plan, the payment plan, and to update your personal data in order to
									create the educational contract.
								</Paragraph>

								<Paragraph style={{ textAlign: "center", margin: "0 auto", maxWidth: "19rem" }}>
									You will be able to enroll multiple children on the same form.
								</Paragraph>
							</Column>

							<Row justify="center">
								<ButtonLink variant="primary" to={reEnrollmentGuardiansPageInfo.to} className={styles["action-button"]}>
									<Row justify="spaced-center" align="center" horizontalSpacing="0.375rem">
										Get Started <Icon.ArrowRight size={20} />
									</Row>
								</ButtonLink>
							</Row>
						</Column>
					</Tile.Body>
				</Tile>
			</Column>

			<Paragraph className={styles["disclaimer"]}>
				Verita International Schools is committed to providing equal access to educational opportunities regardless of
				race, color, religion, national origin, disability, sex, gender identity, or sexual orientation. Our policies,
				procedures, and safer recruitment ensure students are safeguarded from any forms of neglect, physical, sexual,
				or emotional harm.
			</Paragraph>
		</Main>
	);
}
